<template>
	<div>
		<b-container class="container-project py-5 pt-xl-0">
			<!-- Titulos -->
			<b-overlay :show="loading" rounded="lg" spinner-variant="customer">
				<div v-if="showResponse">
					<b-row>
						<b-col cols="12" md="6">
							<div class="h1 text-uppercase">
								<b>{{quote.name}}</b>
							</div>
							<div class="text-grey text-uppercase">
								<span class="h3"><b>Gracias por cotizar</b></span><br />
								<span class="h5">Un ejecutivo te contactará en breve</span>
							</div>
							<div class="h4 text-argenta text-uppercase mt-4">
								<b v-if="quoteResponse">Resumen de cotización Nº {{quoteResponse.code | numberFormat}}</b>
							</div>
							<b-table-simple borderless class="table-quote mt-4">
								<b-tr v-for="(asset, key) in quote.assets" v-bind:key="'quote-asset-' + key">
									<b-td>
										{{getAsset(asset).text}}
									</b-td>
									<b-td class="text-right">
										UF: {{getAsset(asset).price | numberFormat}}
									</b-td>
								</b-tr>
								<b-tr class="white-background">
									<b-td colspan="2"><p></p></b-td>
								</b-tr>
								<b-tr class="bg-argenta text-white text-uppercase h5">
									<b-th>
										Total Cotización
									</b-th>
									<b-th class="text-right text-nowrap">
										UF: {{sumPriceAssets(quote.assets) | numberFormat}}
									</b-th>
								</b-tr>
							</b-table-simple>
							<b-table-simple borderless>
								<b-tr>
									<b-td class="pl-0 w-50"><b-button  v-if="quoteResponse" squared block variant="dark" :href="quoteResponse.document" target="_blank" >Descargar cotización</b-button></b-td>
									<b-td class="pr-0"><b-button squared block variant="dark" @click="cleanModal" target="_blank" >Nueva cotización</b-button></b-td>
								</b-tr>
								<b-tr v-if="quoteResponse && selectedProject.project_id != 4">
									<b-td colspan="2" class="px-0">
										<div style="border: 1px solid grey;">
											<b-button squared block variant="cotizar" :href="'https://reserva.mobysuite.com/argenta/proyecto/'+selectedProject.project_name+'?code='+quoteResponse.code" target="_blank" class="text-uppercase" style="border: 4px solid #FFF" >Reserva online</b-button>
										</div>
									</b-td>
								</b-tr>
							</b-table-simple>
						</b-col>
						<b-col cols="12" md="6" class="image-response"></b-col>
					</b-row>
				</div>
				<div v-else>
					<h2 class="bolder">Cotizar</h2>
					<p class="mt-4 text-secondary">Busca el proyecto que quieres, elige tu próximo departamento y cotízalo. ¡Es fácil, simple y sencillo!</p>
					<div class="mt-5">
						<!-- Cierre Titulos -->
						<!-- Select Proyecto - Depto -->
						<h4>Selecciona el departamento</h4>
						<b-row class="mt-4">
							<b-col cols="6">
								<b-form-group label="Proyecto">
									<multiselect v-if="projects" :allow-empty="false" class="multiselect-sm" v-model="selectedProject" :options="projects" :close-on-select="true" :show-labels="false" placeholder="Seleccionar" :custom-label="setProjectLabel" deselect-label="Eliminar selección" select-label="" selected-label="Seleccionado" @input="setApartments">
										<template slot="noOptions">No hay elementos disponibles.</template>
									</multiselect>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group label="Departamento">
									<multiselect v-if="apartments" :allow-empty="false" class="multiselect-sm" v-model="selectedApartment" :options="apartments" :close-on-select="true" :show-labels="false" placeholder="Seleccionar" :custom-label="setApartmentLabel" deselect-label="Eliminar selección" select-label="" selected-label="Seleccionado">
										<template slot="noOptions">No hay elementos disponibles.</template>
									</multiselect>
								</b-form-group>
							</b-col>
						</b-row>
					</div>
					<!-- Cierre Select Proyecto - Depto -->
					<!-- Info depto -->
					<b-row v-if="selectedApartment" class="my-2">
						<b-col cols="12" xl="6">
							<b-img class="w-100" :src="$store.state.customer_domain+selectedApartment.urlImagenDelBienAComercializarUno"></b-img>
						</b-col>
						<b-col cols="12" xl="6">
							<h2 class="bolder">{{selectedProject.name}} - {{selectedApartment.numeroDeBien}}</h2>
							<!-- Iconos -->
							<div class="mt-4">
								<!-- Item -->
								<div class="mt-3">
									<span>Útil: {{selectedApartment.superficieUtil | numberFormat}}m<sup>2</sup>. Terraza: {{selectedApartment.superficieTerraza | numberFormat}}m<sup>2</sup>. Total: {{selectedApartment.superficieTotal | numberFormat}}m<sup>2</sup> </span>
								</div>
								<!-- Item -->
								<div class="mt-3">
									<span>{{selectedApartment.numeroDeDormitorios | numberFormat}} Habitaci{{selectedApartment.numeroDeDormitorios > 1 ? 'ones' : 'ón'}} </span>
								</div>
								<!-- Item -->
								<div class="mt-3">
									<span>{{selectedApartment.numeroDeBanos | numberFormat}} Baño{{selectedApartment.numeroDeBanos > 1 ? 's' : ''}} </span>
								</div>
							</div>
							<!-- Cierre Iconos -->
							<!-- Select Bodega y Estacionamientos -->
							<b-row class="mt-4">
								<!-- Item -->
								<b-col cols="12" xl="12">
									<b-form-group label="Bodega">
										<multiselect :allow-empty="true" class="multiselect-sm" v-model="selectedCellar" :options="cellars" :close-on-select="true" :show-labels="true" placeholder="Seleccionar" track-by="id" :custom-label="setAssetLabel" deselect-label="Eliminar selección" select-label="" selected-label="Seleccionado">
											<template slot="noOptions">No hay elementos disponibles.</template>
										</multiselect>
									</b-form-group>
								</b-col>
								<!-- Item -->
								<b-col cols="12" xl="12">
									<b-form-group label="Estacionamiento">
										<multiselect :allow-empty="true" class="multiselect-sm" v-model="selectedParking" :options="parkings" :close-on-select="true" :show-labels="true" placeholder="Seleccionar" track-by="id" :custom-label="setAssetLabel" deselect-label="Eliminar selección" select-label="" selected-label="Seleccionado">
											<template slot="noOptions">No hay elementos disponibles.</template>
										</multiselect>
									</b-form-group>
								</b-col>
							</b-row>
							<!-- Cierre Select Bodega y Estacionamientos -->
						</b-col>
					</b-row>
					<b-row>
						<b-col class="my-5">
							<b-button @click="send" variant="argenta" block size="lg" squared class="py-3" >COTIZAR</b-button>
						</b-col>
					</b-row>
					<!-- Cierre Info depto -->
				</div>
			</b-overlay>
		</b-container>
	</div>
</template>
<script>
	export default {
		name: "quote",
		data() {
			return{
				loading: true,
				selectedApartment: null,
				selectedProject: null,
				selectedCellar: null,
				selectedParking: null,
				showResponse: false,
				quote: {
					customer_name: 'argenta',
					project_name: null,
					project_id: null,
					name: null,
					lastname: null,
					email: null,
					cellphone: null,
					rut: null,
					age_range: null,
					commune: null,
					destiny: null,
					subscribe: null,
					assets: []
				},
				projects: null,
				apartments: null,
				cellars: null,
				parkings: null
			}
		},
		mounted() {
			this.quote.rut = this.$auth.user().rut;
			this.quote.name = this.$auth.user().name;
			this.quote.lastname = this.$auth.user().lastname;
			this.quote.email = this.$auth.user().email;
		},
		methods: {
			setApartments() {
				this.loading = true;
			},
			setApartmentLabel(apartment){
				return `${apartment.tipoBien} ${apartment.numeroDeBien}`;
			},
			setProjectLabel(project){
				return `${project.name}`;
			},
			setAssetLabel(asset){
				return `Nº ${asset.number}`;
			},
			send(){
				this.quote.assets  = [this.selectedApartment.id]
				if(this.selectedParking){
					this.quote.assets.push(this.selectedParking.id);
				}
				if(this.selectedCellar){
					this.quote.assets.push(this.selectedCellar.id);
				}
				this.loading = true;
			},
			cleanModal(){
				this.showResponse = false;
			},
			getAsset(assetId){
				let asset = this.apartments.find(asset => asset.id == assetId);
				if(asset == null){
					asset = this.cellars.find(asset => asset.id == assetId);
				}
				if(asset == null){
					asset = this.parkings.find(asset => asset.id == assetId);
				}
				return asset;
			},
			sumPriceAssets(assets){
				let sum = 0;
				assets.forEach( asset => sum += this.getAsset(asset).price );
				return sum;
			},
		},
	};
</script>
<style>

.table-quote tr:nth-of-type(odd) {
	background-color: #e8e8e8;
}
.table-quote td{
	padding: 5px 20px;
}
.table-quote th{
	padding: 10px 20px;
}
</style>
